import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { isLocal } from '../../helpers/local.helper';
import { AppSwitcherService } from '../../services/app-switcher/app-switcher.service';
import { CacheService } from 'src/app/cache.service';
import { NS_Enums } from '../../namespaces';

@Component({
  selector: 'app-app-switcher',
  templateUrl: './app-switcher.component.html',
  styleUrls: ['./app-switcher.component.scss']
})
export class AppSwitcherComponent implements OnInit {

  constructor(private appSwitcherService: AppSwitcherService, private cacheService: CacheService) { }

  ngOnInit(): void {

  }

  open(product){
    const user_details = this.cacheService.getObject<any>(NS_Enums.cacheKeysEnum.user_details);
    if(product === 'PULSE' && !this.appSwitcherService.isPulseEntry){
      this.appSwitcherService.createPulseEntry(user_details.company.companyId);
    }
    const productUrl = isLocal ? 'http://localhost:4200/products' : environment.PRODUCTS[product];
    this.appSwitcherService.appSwitcherDialog?.close();
    window.open(productUrl, '_blank').focus();
  }

}
